import { TextField } from "@mui/material";
import { useDebounce } from "hooks/useDebounce";
import { useState } from "react";

type ContactInputProps = { value: string; onChange: (value: string) => void };

const ContactInput: React.FC<ContactInputProps> = (props) => {
  const { value, onChange } = props;

  const [contactName, setContactName] = useState(value);
  useDebounce(contactName, {
    delayMs: 500,
    onChange: (value) => onChange(value),
  });

  return (
    <TextField
      label="Namn på kontaktperson"
      variant="filled"
      value={contactName}
      onChange={(e) => setContactName(e.target.value)}
    />
  );
};

export default ContactInput;
